import { render, staticRenderFns } from "./user-default.vue?vue&type=template&id=4dd40e22&"
import script from "./user-default.vue?vue&type=script&lang=js&"
export * from "./user-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dd40e22')) {
      api.createRecord('4dd40e22', component.options)
    } else {
      api.reload('4dd40e22', component.options)
    }
    module.hot.accept("./user-default.vue?vue&type=template&id=4dd40e22&", function () {
      api.rerender('4dd40e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/user-default.vue"
export default component.exports